var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.AbstractSubscriptionDataRequest = new Class({
    Extends: OCS.Viewer.Classes.AbstractDataRequest,
    class_name: "AbstractSubscriptionDataRequest",
    options: {
        states: ["Inactive", "Active - Waiting for data", "Active - Initial data recieved", "Complete", "Active - Listening for subscriptions"],
        subscribe: false,
    },
    get_subscription: function () {
        return this.options.subscribe;
    },
    set_subscription: function (val) {
        var old_value = this.options.subscribe;
        this.options.subscribe = val;
        if (this.request_active && old_value !== val) {
            // Need to make a change to the subscription after it was activated
            if (val) {
                // Activate the subscription
                this.fireEvent('subscribe', this);
                if (!this.get_initial_req_timestamp_array().length) {
                    this.update_state(this.options.states.indexOf("Active - Listening for subscriptions"));
                }
            } else {
                // Deactivate the subscription
                this.fireEvent('unsubscribe', this);
                if (this.is_request_completed()) {
                    this.completed();
                }
            }
        }
    },
    success_giveup: function () {
        if (!this.get_subscription()) {
            this.parent();
        }
    },
    timestamp_requested: function (timestamp) {
        if (this.options.initial_req.timestamp_epoch_array.contains(timestamp * 1)) {
            return true;
        } else {
            if (this.options.subscribe && (timestamp * 1 > this.options.initial_req.timestamp_epoch_array[0])) {
                return true;
            }
            return false;
        }
    },
    success: function () {
        this.parent();
        if (!this.get_initial_req_timestamp_array().length && this.get_subscription()) {
            this.update_state(this.options.states.indexOf("Active - Listening for subscriptions"));
        }
    },
    is_request_completed: function () {
        if (this.parent() && !this.get_subscription()) {
            return true;
        } else {
            return false;
        }
    },
    destroy: function () {
        this.parent();
        this.setOptions({
            subscribe: false,
        });
    }
});
